import { getMedias, linkMedia, unlinkMedia } from '../../../app/api';

export async function migrateOrderDraftMediaToHistory(orderId, historyId) {
  if (!orderId || !historyId) return;
  try {
    const response = await getMedias();
    const allMedias = response.data?.medias || [];
    const draftMedias = allMedias.filter((media) => {
      if (!media.metadata?.length) return false;
      return media.metadata.some((meta) => {
        if (meta.key !== 'order_status_draft') return false;
        const v = meta.value;
        if (typeof v === 'object' && v !== null) return String(v.id) === String(orderId);
        return String(v) === String(orderId);
      });
    });
    let ord = 0;
    for (const media of draftMedias) {
      const matchingMeta = media.metadata.find((m) => m.key === 'order_status_draft');
      if (!matchingMeta) continue;
      const metaValue = matchingMeta.value;
      let valueToSend;
      if (typeof metaValue === 'object' && metaValue !== null && metaValue.id != null && String(metaValue.id).trim() !== '') {
        valueToSend = String(metaValue.id);
      } else if (typeof metaValue === 'object' && metaValue !== null) {
        valueToSend = JSON.stringify(metaValue);
      } else {
        valueToSend = String(metaValue);
      }
      await unlinkMedia(media.id, 'order_status_draft', valueToSend);
      const title =
        typeof metaValue === 'object' && metaValue !== null && metaValue.title
          ? metaValue.title
          : media.filename;
      await linkMedia(media.id, {
        order_status_history: JSON.stringify({
          id: historyId,
          url: '',
          title,
          order: ord++,
        }),
      });
    }
  } catch (e) {
    console.error('migrateOrderDraftMediaToHistory:', e);
  }
}
